var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToiletPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 39V27.75H12V19.5C12 17.85 13.35 16.5 15 16.5H19.5C21.15 16.5 22.5 17.85 22.5 19.5V27.75H20.25V39H14.25ZM33 39V30H37.5L33.69 18.555C33.4893 17.9576 33.1065 17.438 32.5953 17.0694C32.0841 16.7008 31.4702 16.5017 30.84 16.5H30.66C30.0292 16.4994 29.4143 16.6977 28.9027 17.0666C28.391 17.4355 28.0087 17.9563 27.81 18.555L24 30H28.5V39H33ZM17.25 15C18.915 15 20.25 13.665 20.25 12C20.25 10.335 18.915 9 17.25 9C15.585 9 14.25 10.335 14.25 12C14.25 13.665 15.585 15 17.25 15ZM30.75 15C32.415 15 33.75 13.665 33.75 12C33.75 10.335 32.415 9 30.75 9C29.085 9 27.75 10.335 27.75 12C27.75 13.665 29.085 15 30.75 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToiletPoi);
export default __webpack_public_path__ + "static/media/toilet-poi.01bca245bc22169ecd48fb54021b4980.svg";
export { ForwardRef as ReactComponent };